import { Link } from "react-router-dom";

export function DesktopNavigation() {
  return (
    <div className="hidden lg:flex items-center space-x-8">
      <Link
        to="/artists"
        className="text-white hover:text-primary-light transition-colors"
      >
        Artists
      </Link>
      <Link
        to="/sponsors"
        className="text-white hover:text-primary-light transition-colors"
      >
        Sponsors
      </Link>
      <Link
        to="/playlists"
        className="text-white hover:text-primary-light transition-colors flex items-center gap-1.5"
      >
        Playlists
      </Link>
      <Link
        to="/songs"
        className="text-white hover:text-primary-light transition-colors"
      >
        Songs
      </Link>
      <Link
        to="/community"
        className="text-white hover:text-primary-light transition-colors"
      >
        Community
      </Link>
      <Link
        to="/charts"
        className="text-white hover:text-primary-light transition-colors"
      >
        Charts
      </Link>
      <Link
        to="/profiles"
        className="text-white hover:text-primary-light transition-colors"
      >
        Discover
      </Link>
      <Link
        to="/plans"
        className="text-white hover:text-primary-light transition-colors flex items-center gap-1.5"
      >
        Plans
        <span className="bg-primary text-primary-foreground text-[10px] font-semibold px-1.5 py-0.5 rounded-full uppercase">
          New
        </span>
      </Link>
    </div>
  );
}

